import { Box, Tabs, Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { hasPermission } from 'store'
import { useSession } from 'components/Providers'
import { search as fetchNeedsAttention } from 'store/asset/need-attention'

export const tabConfig = [
  {
    index: 0,
    label: "My Devices",
    path: "my-devices",
    permission: 'miscellaneous.device',
    visibleAtCampus: true
  },
  {
    index: 1,
    label: "Needs Attention",
    path: "needs-attention",
    permission: 'miscellaneous.device',
    visibleAtCampus: true,
    notificationIcon: true
  },
  {
    index: 2,
    label: "Add Devices",
    path: "add-devices",
    permission: 'miscellaneous.device',
    visibleAtCampus: false
  }
]

export default function AssetTabs() {
  const basePath = `/asset-management`
  const theme = useSelector(state => state.session.appearance)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { '*': tabName } = useParams()
  const { district } = useSession();
  const recentlyAdded = useSelector(state => state.asset.needsAttention.recentlyAdded)
  const pendingAcceptance = useSelector(state => state.asset.needsAttention.pendingAcceptance)
  const inactiveAssigned = useSelector(state => state.asset.needsAttention.inactiveAssigned)
  const hasNeedsAttention = recentlyAdded?.length > 0 || pendingAcceptance?.length > 0 || inactiveAssigned?.length > 0

  useEffect(() => {
    if (!recentlyAdded) dispatch(fetchNeedsAttention())
  }, [dispatch, Boolean(recentlyAdded)])

  const permittedTabs = tabConfig.filter(tab =>
    hasPermission(tab.permission) &&
    (tab.visibleAtCampus || district?.isServiceProvider)
  );

  const getTabIndex = path => {
    const [tabName] = path.split("/");
    const found = permittedTabs.find(tab => tab.path === tabName);
    return found ? found.index : permittedTabs[0]?.index ?? 0;
  };
  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName));
  }, [tabName, permittedTabs.length]);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        <Tabs value={tabIndex}>
          {permittedTabs.map(tab => (
            <Tab
              key={tab.path}
              sx={{ color: tabIndex === tab.index && "primary !important", position: 'relative' }}
              className={tabIndex === tab.index
                ? `tab-item-selected`
                : `tab-item-${theme}`
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {t(tab.label)}
                  {tab.notificationIcon && hasNeedsAttention && (
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: 'error.main',
                        animation: 'pulse 2s infinite',
                        '@keyframes pulse': {
                          '0%, 100%': { opacity: 1 },
                          '50%': { opacity: 0.5 }
                        }
                      }}
                    />
                  )}
                </Box>
              }
              value={tab.index}
              component={Link}
              to={`${basePath}/${tab.path}`}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}
